/**
 * src/components/business-page/BusinessGallery.js
 *
 * Hero image + carrusel de 5 thumbnails con flechas prev/next.
 * Props: { image, gallery: string[], name: string }
 */

import { define } from '@components/Component.js'
import { h } from '@core/dom.js'
import { signal, effect } from '@core/signal.js'
import { openLightbox } from '@components/shared/lightbox.js'

define('BusinessGallery', ({ image, gallery = [], name }) => {
    /* Las 5 imágenes: hero + las del gallery (máx 5 en total) */
    const images = [image, ...gallery].slice(0, 5)
    const active  = signal(0)

    /* ── Hero ── */
    const heroImg = h('img', {
        src:       images[0],
        alt:       name,
        className: 'biz-gallery__hero-img'
    })

    effect(() => { heroImg.src = images[active.get()] })

    heroImg.style.cursor = 'zoom-in'
    heroImg.addEventListener('click', () => openLightbox(images, active.get()))

    const heroWrap = h('div', { className: 'biz-gallery__hero' }, heroImg)

    /* ── Thumbnails ── */
    const thumbEls = images.map((src, i) => {
        const thumb = h('button', {
            className: 'biz-gallery__thumb',
            type:      'button'
        },
            h('img', { src, alt: `${name} foto ${i + 1}`, className: 'biz-gallery__thumb-img' })
        )
        thumb.addEventListener('click', () => active.set(i))
        effect(() => thumb.classList.toggle('biz-gallery__thumb--active', active.get() === i))
        return thumb
    })

    /* ── Flechas ── */
    const prev = h('button', {
        className: 'biz-gallery__arrow biz-gallery__arrow--prev',
        type:      'button',
        'aria-label': 'Anterior'
    }, '‹')

    const next = h('button', {
        className: 'biz-gallery__arrow biz-gallery__arrow--next',
        type:      'button',
        'aria-label': 'Siguiente'
    }, '›')

    prev.addEventListener('click', () =>
        active.set(active.get() === 0 ? images.length - 1 : active.get() - 1)
    )
    next.addEventListener('click', () =>
        active.set(active.get() === images.length - 1 ? 0 : active.get() + 1)
    )

    if (images.length <= 1) {
        return h('div', { className: 'biz-gallery' }, heroWrap)
    }

    const thumbsRow = h('div', { className: 'biz-gallery__thumbs-wrap' },
        prev,
        h('div', { className: 'biz-gallery__thumbs' }, ...thumbEls),
        next
    )

    return h('div', { className: 'biz-gallery' },
        heroWrap,
        thumbsRow
    )
})
